<script setup lang="ts">
import type { SafeHtmlString } from "../utils/sanitize";

// NB : un `<component :is>` dynamique ne sérialise PAS le v-html côté SSR (le compilateur SSR
// route le tag dynamique comme un composant et ignore innerHTML) → contenu vide au rendu serveur.
// On rend donc un élément statique, seul cas où @vue/compiler-ssr émet bien le innerHTML.
defineProps<{ content: SafeHtmlString }>();
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="content" />
</template>
